// src/ThankYouPage.js

function ThankYou() {
    return (
      <div className="text-2xl">
        <h1>Thank You!</h1>
        <p>Your submission has been received. We will get back to you soon.</p>
      </div>
    );
  }
  
  
  export default ThankYou;
  